enum Apps {
    CORE = 'adultswim',
    SSO = 'sso',
}

export default Apps;
